import { render, staticRenderFns } from "./BuildingDetailPage.vue?vue&type=template&id=0f386d94&"
import script from "./BuildingDetailPage.vue?vue&type=script&lang=ts&"
export * from "./BuildingDetailPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports